module.exports = __webpack_public_path__ + "media/application/images/svgs/folder-plus-2caef3c589d60ac868f4bcd37963a94e.svg";